/*
 * Basic history state manager that can be used by basic routers within pages
 *
 * This uses a Spruce store variable - history, that changes when the history state changhes
 * this can be watched by Alpine objects which can contiain a router() function, called by init()
 * this allows additional states to be pushed and popped, and data to be stored on the state
 */
window.historyManager = {
    init: function() {
        let url = location.hash.replace('#/', '');
        history.replaceState({url}, null, '#/' + url);
        Spruce.store('history', {pushed: false, root: true, url});
    },
    reset: function() {
        history.replaceState({url: ''}, null, '#/');
    },
    replace: function(url, state) {
        history.replaceState({url, ...state}, null, '#/' + url);
    },
    push: function(url, state) {
        history.pushState({url, ...state}, null, '#/' + url);
        Spruce.reset('history');
        Spruce.store('history', {pushed: true, url, ...state});
    },
    pop: function() {
        history.back();
    },
    popstateHandler: function(event) {
        let url = location.hash.replace('#/', '');
        Spruce.reset('history');
        Spruce.store('history', {pushed: false, url, ...event.state});
    }

}
document.addEventListener('DOMContentLoaded', historyManager.init );
window.addEventListener("popstate", historyManager.popstateHandler);
